<mat-dialog-content>
  <div class="return-dialog-message">{{ data.message }}</div>
  <p *ngIf="isExchange" class="return-dialog-note">
    The original invoice stays historical. This creates a linked exchange job
    so you can select the replacement frame at current pricing. Defective frames
    should use the warranty workflow instead.
  </p>
  <p *ngIf="isReturn" class="return-dialog-note">
    The original invoice stays unchanged. This creates a linked return
    (invoice-RT). Defective frames should use the warranty workflow instead.
  </p>

  <ng-container *ngIf="isReturn">
    <div class="return-dialog-net">
      Original Eligible Amount Paid: ${{ eligibleDisplay }}
    </div>
    <mat-checkbox [(ngModel)]="applyRestockingFee" class="return-dialog-checkbox">
      RESTOCKING FEE ({{ restockingFeePercent }}%)
    </mat-checkbox>
    <div class="return-dialog-fee" *ngIf="applyRestockingFee">
      Restocking fee: ${{ restockingFeeDisplay }}
    </div>
    <div class="return-dialog-net">
      Customer Credit: ${{ netCreditDisplay }}
    </div>
    <mat-checkbox [(ngModel)]="returnToInventory" class="return-dialog-checkbox">
      Frame is sellable / return to inventory
    </mat-checkbox>
  </ng-container>

  <ng-container *ngIf="!isReturn">
    <mat-form-field class="return-dialog-field">
      <input
        matInput
        placeholder="CREDIT"
        (blur)="formatCurrency('credit')"
        [(ngModel)]="credit"
      />
      <span matPrefix>$&nbsp;</span>
    </mat-form-field>
    <ng-container *ngIf="!creditOnly">
      <mat-form-field class="return-dialog-field">
        <input
          matInput
          placeholder="RESTOCKING FEE"
          (blur)="formatCurrency('restockingFee')"
          [(ngModel)]="restockingFee"
        />
        <span matPrefix>$&nbsp;</span>
      </mat-form-field>
      <div class="return-dialog-net">
        NET CREDIT: ${{ netCreditDisplay }}
      </div>
      <mat-checkbox [(ngModel)]="returnToInventory" class="return-dialog-checkbox">
        Frame passes visual inspection / return to inventory
      </mat-checkbox>
    </ng-container>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
  <button
    mat-raised-button
    color="primary"
    [disabled]="!canConfirm"
    (click)="return()"
  >
    {{ confirmLabel }}
  </button>
  <button mat-raised-button (click)="cancel()">CANCEL</button>
</mat-dialog-actions>
